export default class Satisfaction {
  updateEndpoint: string;
  level?: SatisfactionLevel;
}

export enum SatisfactionLevel {
  GOOD = "GOOD",
  AVERAGE = "AVERAGE",
  POOR = "POOR",
}
